<!-- ----------------------------------------------- -->
<template>
  <v-sheet
    class="tm-pc-detail-frame container-column"
    v-if="tmSnowList.length !== 0"
  >
    <div class="tm-pc-detail-frame-box">
      <v-row class="mx-0">
        <v-col class="tm-pc-detail-frame-info">
          <tm-snow-detail-info></tm-snow-detail-info>
        </v-col>
      </v-row>

      <v-row class="mx-0 flex-row">
        <v-col
          v-if="obsDispStatusGraph && reload"
          class="tm-pc-detail-frame-graph flex-4 pr-1 pb-1"
        >
          <v-card class="com-pc-card">
            <v-row class="com-pc-card-header">
              <span class="com-pc-card-title">{{ cardTitle.graph }}</span>
            </v-row>
            <div
              ref="snowDetailGraphBox"
              class="com-pc-card-contents pl-0 pr-0 pb-2"
              style="height: 60vh;"
            >
              <tm-snow-graph
                :width="widthGraph"
                :height="heightGraph"
                :isExpansion="scalMode"
                :isLegend="isLegendDisp"
              ></tm-snow-graph>
            </div>
          </v-card>
        </v-col>

        <v-col
          v-if="obsDispStatusValues && reload"
          class="tm-pc-detail-frame-values flex-3"
        >
          <v-card class="com-pc-card">
            <v-row class="com-pc-card-header">
              <span class="com-pc-card-title">{{ cardTitle.values }}</span>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    x-small
                    color="white"
                    class="mr-2"
                    v-clipboard:copy="copyValues"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ btnLabel.copy }}</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="tm-pcfull-detail-copy-dialog">
                    <span class="message">{{ dialogMessage }}</span>
                  </v-card-title>
                </v-card>
              </v-dialog>
              <v-btn
                outlined
                x-small
                color="white"
                class="mr-2"
                @click="print()"
              >
                <span>{{ btnLabel.print }}</span>
              </v-btn>
              <v-btn
                outlined
                x-small
                color="white"
                class="mr-2"
                @click="pastBtnClick()"
              >
                <span>{{ btnLabel.past }}</span>
              </v-btn>
            </v-row>
            <div
              ref="snowDetailValueBox"
              class="com-pc-card-contents pl-0 pr-0"
              style="height: 60vh;"
            >
              <tm-snow-detail-values></tm-snow-detail-values>
              <tm-snow-detail-past
                v-if="pastOpen"
                @close="pastOpen = false"
              ></tm-snow-detail-past>
            </div>
          </v-card>
        </v-col>

        <!-- 「表示切替カード」の左の余白 -->
        <v-col v-if="!obsDispStatusGraph && !obsDispStatusValues" cols="10">
        </v-col>

        <v-col cols="2" class="tm-pc-detail-frame-contents pb-1">
          <tm-snow-detail-config></tm-snow-detail-config>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]積雪 詳細フレーム
 * TmSnowDetailFrame.vue
 * @author LIS
 */
import TmSnowDetailInfo from "./TmSnowDetailInfo.vue";
import TmSnowGraph from "../TmSnowGraph.vue";
import TmSnowDetailValues from "./TmSnowDetailValues.vue";
import TmSnowDetailPast from "./TmSnowDetailPast.vue";
import TmSnowDetailConfig from "./TmSnowDetailConfig.vue";
import PageLog from "./../../../lib/pageLog.js";
import Util from "./../../../lib/util.js";

export default {
  name: "tm-snow-detail-frame",
  components: {
    TmSnowDetailInfo,
    TmSnowGraph,
    TmSnowDetailValues,
    TmSnowDetailPast,
    TmSnowDetailConfig,
  },
  data() {
    return {
      pastOpen: false,
      cardTitle: {
        graph: "積雪グラフ",
        values: "観測値一覧",
      },
      btnLabel: {
        past: "過去一週間",
        copy: "コピー",
        print: "印刷",
      },
      widthGraph: 10,
      heightGraph: 10,
      reload: true,
      dialogMessage: "コピーしました。",
      dialog: false,
    };
  },
  beforeCreate() {
    this.$log.debug("[TmObs] beforeCreate()");
    // 観測日時を設定
    if (this.$route.query["isCurrent"] == "false") {
      this.$store.commit("app/setTime", this.$route.query.appTime);
    }
  },
  created: function() {
    window.addEventListener("resize", this.obsDispStatusResize);
  },
  mounted() {
    this.setDispHgt();
    this.obsDispStatusResize();
  },
  updated() {
    this.setDispHgt();
    this.obsDispStatusResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.obsDispStatusResize);
  },
  computed: {
    /** 拡縮表示設定 */
    scalMode: {
      get() {
        return this.$store.state.Telemeter.scalMode;
      },
    },
    /** 凡例表示状態 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
    },
    /** コンテンツ切替(河川予警報) */
    obsDispStatusRiverWarnInfo: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.riverWarnInfo;
      },
    },
    /** コンテンツ切替(お知らせ) */
    obsDispStatusInfo: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.info;
      },
    },
    /** コンテンツ切替(グラフ表示) */
    obsDispStatusGraph: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.obsGraph;
      },
    },
    /** コンテンツ切替(観測値一覧) */
    obsDispStatusValues: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.valuesList;
      },
    },
    obsCardDispStatus: {
      get() {
        return (
          this.obsDispStatusGraph.toString() +
          this.obsDispStatusValues.toString()
        );
      },
    },
    /** コンテンツ切替 */
    obsDispStatus: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus;
      },
    },
    /** 積雪情報取得 */
    tmSnowList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** 観測日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /** 観測日時(ファイル取得用) */
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam: {
      get() {
        if (
          this.$store.state.Telemeter.pageLogParam &&
          this.$store.state.Telemeter.pageLogParam.obsData
        ) {
          return {
            prefCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .prefCd,
            twnCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .twnCd,
            rvrCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .rvrCd,
            obsCd: this.$store.state.Telemeter.pageLogParam.payload.obsFcd,
            appTime: this.$store.state.Telemeter.pageLogParam.payload.appTime,
          };
        }
        return null;
      },
    },
    /**
     * 積雪深情報(時間) 取得
     */
    hourList: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.hour;
      },
    },
    /** クリップボードコピー用 */
    copyValues: {
      get() {
        return this.hourList.copyValues.join("\n");
      },
    },
  },
  watch: {
    obsCardDispStatus() {
      // コンテンツ切替のタイミングで一旦最小表示にした上で、リサイズする。
      this.widthGraph = 10;
      this.heightGraph = 10;

      this.obsDispStatusResize();
    },
    appTimeRound() {
      // 観測日時(ファイル取得用)
      this.getTmSnowDatas();
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam(to, from) {
      if (to && (!from || to.appTime != from.appTime)) {
        // アクセスログ出力
        PageLog.log({
          page_log: "snow_detail",
          pref_cd: to.prefCd,
          twn_cd: to.twnCd,
          rvr_cd: to.rvrCd,
          obs_cd: to.obsCd,
          device_sb: "pc",
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
    },
    dialog() {
      // 指定秒後ダイアログを閉じる
      setTimeout(() => {
        this.dialog = false;
      }, 1000);
      // 指定秒後ボタンのfocusを解除する
      setTimeout(() => {
        const elem = document.activeElement;
        elem.blur();
      }, 1200);
    },
  },
  methods: {
    obsDispStatusResize() {
      this.$nextTick(() => {
        if (this.$refs.snowDetailGraphBox !== undefined) {
          // グラフカードのサイズ変更
          const offsetWidth = this.$refs.snowDetailGraphBox.offsetWidth;
          const offsetHeight = this.$refs.snowDetailGraphBox.offsetHeight;
          if (offsetWidth > 0 && offsetHeight > 0) {
            this.widthGraph = offsetWidth - 48;
            this.heightGraph = offsetHeight - 8;
          }
        }
      });
    },
    // 積雪を取得
    getTmSnowDatas() {
      setTimeout(() => {
        this.$store
          .dispatch("Telemeter/getSelectedTm", {
            ofcCd: this.$route.query.ofcCd,
            itmkndCd: this.$route.query.itmkndCd,
            obsCd: this.$route.query.obsCd,
            appTime: this.appTime,
            appTimeRound: this.appTimeRound,
          })
          .then(() => {
            // リサイズ後、リロードする
            this.obsDispStatusResize();
            this.reload = false;
            this.$nextTick(() => (this.reload = true));
          });
      }, 500);
    },
    // 表示されるコンテンツの高さを設定
    setDispHgt() {
      this.$nextTick(() => {
        var cnt = 0;
        if (this.obsDispStatusGraph) {
          cnt++;
        }
        if (this.obsDispStatusValues) {
          cnt++;
        }

        if (cnt == 2) {
          if (this.$refs.snowDetailGraphBox != undefined) {
            this.$refs.snowDetailGraphBox.style.height = "50vh";
          }
          if (this.$refs.snowDetailValueBox != undefined) {
            this.$refs.snowDetailValueBox.style.height = "50vh";
          }
        } else if (cnt == 1) {
          if (this.$refs.snowDetailGraphBox != undefined) {
            this.$refs.snowDetailGraphBox.style.height = "60vh";
          }
          if (this.$refs.snowDetailValueBox != undefined) {
            this.$refs.snowDetailValueBox.style.height = "60vh";
          }
        }
      });
    },
    // 過去一週間ボタン押下時処理
    pastBtnClick() {
      this.pastOpen = true;
      // アクセスログ出力
      const tm = this.$store.state.Telemeter.pageLogParam;
      PageLog.log({
        page_log: "snow_past",
        pref_cd: tm.obsData.obsInfo.prefCd,
        twn_cd: tm.obsData.obsInfo.twnCd,
        rvr_cd: tm.obsData.obsInfo.rvrCd,
        obs_cd: tm.payload.obsFcd,
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
    // 観測値一覧を印刷する
    print() {
      if (!this.$store.state.app.isCurrent) {
        let routeData = this.$router.resolve({
          name: "printPreview",
          query: {
            itmkndCd: this.$route.query.itmkndCd,
            ofcCd: this.$route.query.ofcCd,
            obsCd: this.$route.query.obsCd,
            appTime: Util.formatDate(
              this.$store.state.app.appTime,
              "YYYY-MM-DD HH:mm"
            ),
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$route.query.fld,
            timeMode: true,
            type: "values",
          },
        });
        window.open(
          routeData.href,
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );
      } else {
        let routeData = this.$router.resolve({
          name: "printPreview",
          query: {
            itmkndCd: this.$route.query.itmkndCd,
            ofcCd: this.$route.query.ofcCd,
            obsCd: this.$route.query.obsCd,
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$route.query.fld,
            timeMode: true,
            type: "values",
          },
        });
        window.open(
          routeData.href,
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
